{
  "removeButtonLabel": "Supprimer",
  "removeDescription": "Appuyez sur Supprimer pour supprimer l’étiquette."
}
